module.exports = __webpack_public_path__ + "static/media/video.be543120.png";